import Vue from 'vue';
import Vuex from 'vuex';
import createMultiTabState from "vuex-multi-tab-state";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentLoc: 0,
    locations: [],
    menuOpen: false
  },
  mutations: {
    setMenuOpen(state) {
      state.menuOpen = !state.menuOpen;
    },
    setCurrentLocation(state, loc) {
      state.currentLoc = loc;
    },

    setLocations(state, locations) {
      Vue.set(state, 'locations', locations);
    },
    addLoc(state, loc) {
      state.locations.push(loc);
    },
    removeLoc(state, index) {
      state.locations.splice(index, 1);
    },
    setLocationWeather(state, { index, weather }) {
      Vue.set(state.locations[index], 'weather', weather);
    },
    setLocationLoaded(state, { index, loaded }) {
      Vue.set(state.locations[index], 'loaded', loaded);
    }
  },
  actions: {
    refreshLocation(context, index) {
      context.commit('setLocationLoaded', { index, loaded: false });

      const loc = context.state.locations[index];
      let url = new URL("https://api.openweathermap.org/data/2.5/onecall");
      url.search = new URLSearchParams({
        lat: loc.center[1],
        lon: loc.center[0],
        appid: "67808e28c002794e4e78ddda02d33a87",
        lang: "fr",
        units: "metric",
      }).toString();

      fetch(url)
        .then((r) => r.json())
        .then((r) => {
          context.commit("setLocationWeather", { index, weather: r });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          context.commit('setLocationLoaded', { index, loaded: true });
        });
    },
    refreshAllLocations(context) {
      context.state.locations.forEach((loc, index) => {
        context.dispatch('refreshLocation', index);
      });
    }
  },
  plugins: [
    createMultiTabState()
  ]
});
